// Importing jquery because the actual validation is done using jquery.validation plugin
import $ from 'jquery'

export class ReservationFormValidator {
  constructor (form) {
    this.form = form
  }

  isFormValid () {
    return $(this.form).valid()
  }
}

/**
 * DataLayer updater for ReservationForm on /rezerwacja
 */
export default class ReservationForm {
  static get forms () {
    return document.querySelectorAll('.page--order form')
  }

  /**
   * @param {HTMLFormElement} form
   */
  constructor (form) {
    this.form = form
    this.addEventListenerToForm()
  }

  formSubmissionSuccess () {
    window.dataLayer.push({ event: 'formSubmissionSuccess', formId: 'reservationForm' })
  }

  formSubmissionFailed () {
    window.dataLayer.push({ event: 'formSubmissionFailed', formId: 'reservationForm' })
  }

  isFormValid () {
    return new ReservationFormValidator(this.form).isFormValid()
  }

  updateDataLayer () {
    if (this.isFormValid()) {
      this.formSubmissionSuccess()
    } else {
      this.formSubmissionFailed()
    }
  }

  addEventListenerToForm () {
    this.form.addEventListener('submit', this.updateDataLayer.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/modules/datalayer/ReservationForm.js